import { render, staticRenderFns } from "./CmgRewardExtrasExplainerModal.vue?vue&type=template&id=18c776b2&scoped=true&lang=pug"
import script from "./cmg-reward-extras-explainer-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-extras-explainer-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardExtrasExplainerModal.vue?vue&type=style&index=0&id=18c776b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c776b2",
  null
  
)

export default component.exports